import type { AbortError, HttpError, TimeoutError } from './errors';

export const isHttpError = (error: unknown): error is HttpError => {
  return error instanceof Error && error.name === 'HttpError';
};

export const isAbortError = (error: unknown): error is AbortError => {
  return error instanceof Error && error.name === 'AbortError';
};

export const isTimeoutError = (error: unknown): error is TimeoutError => {
  return error instanceof Error && error.name === 'TimeoutError';
};

export const isNetworkFail = (error: unknown) => {
  return (
    isTimeoutError(error) ||
    (isHttpError(error) && typeof error.status === 'undefined')
  );
};

export const isServerError = (error: unknown): error is HttpError => {
  return isHttpError(error) && error.status >= 500;
};

export const isAuthError = (error: unknown): error is HttpError => {
  return isHttpError(error) && error.status === 401;
};

export const isForbiddenError = (error: unknown): error is HttpError => {
  return isHttpError(error) && error.status === 403;
};
